var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "modal",
      staticClass: "modal fade",
      attrs: { tabindex: "-1", role: "form" }
    },
    [
      _c("div", { staticClass: "modal-dialog modal-lg" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-body" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "container text-center" }, [
              _c("h1", [_vm._v(_vm._s(_vm.title))]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.copy))])
            ]),
            _vm._v(" "),
            _c(
              "form",
              {
                ref: "form",
                attrs: { action: _vm.formAction, method: "post" },
                on: { submit: _vm.checkForm }
              },
              [
                _c("input", {
                  attrs: {
                    type: "hidden",
                    id: "score",
                    name: "score",
                    value: "0.0"
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "container" },
                  [
                    !_vm.complete
                      ? [
                          _vm.formError
                            ? _c(
                                "div",
                                { staticClass: "alert alert-danger fade show" },
                                [
                                  _vm._v(
                                    "\n                An error occurred while submitting the form. Please check all fields and try again.\n              "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.requiredError
                            ? _c(
                                "div",
                                {
                                  staticClass: "alert alert-danger fade show",
                                  attrs: { role: "alert" }
                                },
                                [
                                  _c("b", [
                                    _vm._v(
                                      "Please enter your information for all required fields."
                                    )
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.recaptchaError
                            ? _c(
                                "div",
                                {
                                  staticClass: "alert alert-danger fade show",
                                  attrs: { role: "alert" }
                                },
                                [
                                  _c("b", [
                                    _vm._v(
                                      "Failed to submit form. Please try again."
                                    )
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-md-6" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.firstName,
                                    expression: "firstName"
                                  }
                                ],
                                class: { "has-error": _vm.firstNameError },
                                attrs: {
                                  type: "text",
                                  placeholder: "First Name *"
                                },
                                domProps: { value: _vm.firstName },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.firstName = $event.target.value
                                  }
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-6" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.lastName,
                                    expression: "lastName"
                                  }
                                ],
                                class: { "has-error": _vm.lastNameError },
                                attrs: {
                                  type: "text",
                                  placeholder: "Last Name *"
                                },
                                domProps: { value: _vm.lastName },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.lastName = $event.target.value
                                  }
                                }
                              })
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-md-6" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.email,
                                    expression: "email"
                                  }
                                ],
                                class: { "has-error": _vm.emailError },
                                attrs: {
                                  type: "email",
                                  placeholder: "Enter Email Address *"
                                },
                                domProps: { value: _vm.email },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.email = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("input", {
                                staticClass: "tracer",
                                attrs: {
                                  name: "tracer",
                                  type: "text",
                                  placeholder: "Contact Tracer *"
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-6" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.zip,
                                    expression: "zip"
                                  }
                                ],
                                attrs: {
                                  type: "text",
                                  placeholder: "School ZIP code"
                                },
                                domProps: { value: _vm.zip },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.zip = $event.target.value
                                  }
                                }
                              })
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-center" }, [
                      _vm.complete
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-default bg-orange white",
                              attrs: { "data-dismiss": "modal" }
                            },
                            [_vm._v("CLOSE WINDOW\n              ")]
                          )
                        : _c(
                            "button",
                            {
                              staticClass: "btn btn-default bg-orange white",
                              attrs: { type: "submit" }
                            },
                            [
                              _vm.sending
                                ? [
                                    _c("i", {
                                      staticClass: "fas fa-circle-notch fa-spin"
                                    }),
                                    _vm._v(" SIGNING YOU UP!")
                                  ]
                                : [_vm._v("SIGN ME UP!")]
                            ],
                            2
                          )
                    ])
                  ],
                  2
                )
              ]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close"
        }
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }